import { motion } from 'framer-motion';

const VentLogo = ({ size = 'default', className = '' }) => {
  const sizes = {
    small: { fontSize: 'text-xl sm:text-2xl' },
    default: { fontSize: 'text-2xl' },
    large: { fontSize: 'text-4xl sm:text-5xl' },
  };

  const { fontSize } = sizes[size] || sizes.default;

  return (
    <h1 className={`font-heading font-bold tracking-tighter ${fontSize} ${className}`}>
      <span className="text-vent-secondary text-glow-green">V</span>
      <span className="text-white light-theme:text-zinc-900">ENT</span>
    </h1>
  );
};

// Animated version for splash screen
export const VentLogoAnimated = ({ size = 'large', className = '' }) => {
  return (
    <motion.h1 
      className={`font-heading font-black tracking-tighter text-6xl sm:text-7xl lg:text-8xl ${className}`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <span className="text-vent-secondary text-glow-green">V</span>
      <span className="text-white">ENT</span>
    </motion.h1>
  );
};

export default VentLogo;
